import { RootState } from '..';

export const selectorStep = (state: RootState) => state.view.step;
